// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"SelectAll-primaryButton-2R9F8n","container":"SelectAll-container-YnX8k-","checkbox":"SelectAll-checkbox-2URkPQ","name":"SelectAll-name-1LhSj9"};